<template>
  <div class="sendBill">
    <div class="head">
      <div class="title">发货单信息</div>
      <div class="barCode">
        <div class="bar">
          <barcode :value="productInfo.sn" :options="barcode_option"></barcode>
        </div>
        <div class="code">{{ productInfo.sn }}</div>
      </div>
    </div>
    <div class="content">
      <div class="desc">
        <div>
          <span>商家名称：</span>
          <span>{{ productInfo.companyName }}</span>
        </div>
        <div>
          <span>顾客姓名：</span>
          <span>{{ productInfo.customerName }}</span>
        </div>
        <div>
          <span>下单时间：</span>
          <span>{{ productInfo.orderTime }}</span>
        </div>
      </div>
      <table>
        <tr class="tableTitle">
          <td>型号编码</td>
          <td>型号名称</td>
          <td>数量</td>
        </tr>
        <tr
          class="tableContent"
          v-for="item in productInfo.productCategories"
          :key="item.productSn"
        >
          <td>{{ item.productSn }}</td>
          <td>{{ item.productName }}</td>
          <td>{{ item.quantity }}</td>
        </tr>
      </table>
    </div>
    <div class="line"></div>
  </div>
</template>

<script>
import barcode from "@xkeshi/vue-barcode";
export default {
  props: ["productInfo"],
  components: { barcode },
  data() {
    return {
      barcode_option: {
        displayValue: false, //是否默认显示条形码数据
        background: "#fff", //条形码背景颜色
        height: (window.screen.width * 5) / 100,
        width: window.screen.width / 440,
        lineColor: "#606266",
      },
    };
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="less" scoped>
.sendBill {
  width: 670px;

  .head {
    width: 606px;
    height: 127px;

    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    .title {
      width: 160px;
      height: 45px;
      line-height: 45px;
      font-size: 32px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.9);
      margin-top: 18px;
    }
    .barCode {
      width: 324px;
      height: 127px;

      .bar {
        width: 320px;
        height: 80px;
      }
      .code {
        width: 324px;
        height: 40px;
        line-height: 40px;
        font-size: 28px;
        font-weight: bold;
        color: rgba(0, 0, 0, 1);
      }
    }
  }
  .content {
    width: 670px;
    min-height: 300px;
    background: rgba(255, 255, 255, 1);
    border-radius: 16px;
    margin-top: 32px;
    padding: 32px;
    box-sizing: border-box;
    .desc {
      width: 606px;
      height: 168px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      div {
        width: 606px;
        height: 40px;
        display: flex;
        justify-content: space-between;
      }
    }
    table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 40px;
      .tableTitle {
        text-align: center;
        td {
          background: rgba(242, 243, 247, 1);
          font-size: 28px;
          color: rgba(0, 0, 0, 0.9);
          height: 64px;
        }
        td:nth-child(1) {
          width: 30%;
        }
        td:nth-child(2) {
          width: 50%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        td:nth-child(3) {
          width: 50%;
        }
      }
      .tableContent {
        width: 100%;
        td {
          background: rgba(251, 251, 251, 1);
          font-size: 22px;
          text-align: center;
          height: 64px;
        }
        td:nth-child(2) {
          width: 50%;
        }
      }
    }
  }
  .line {
    width: 100%;
    border-top: 1px dashed rgba(0, 0, 0, 0.4);
    margin-top: 40px;
  }
}
</style>
